import { Messages } from '@wix/podcasts-common/dist/dev-env/constants';

function onMessage(settingsStore, messageData) {
  try {
    const data = JSON.parse(messageData);
    if (data.message === Messages.UPDATE_SETTINGS) {
      settingsStore.set(JSON.parse(data.payload));
    }
  } catch (e) {}
}

function syncSettingsWithDevEditor(settingsStore) {
  window.addEventListener(
    'message',
    (e) => onMessage(settingsStore, e.data),
    false,
  );
}

export default syncSettingsWithDevEditor;
